import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-slides',
  templateUrl: './slides.component.html',
  styleUrls: ['./slides.component.scss']
})
export class SlidesComponent implements OnInit {
indice!:number;
ngOnInit(): void {
  this.indice = 1;
}
//---------------------------


}
